module.exports = __webpack_public_path__ + "img/2.2515873b.jpg";